import { CodeTableNumber } from '../interfaces';

export const CODES_INDEPENDENT_OF_SUBSCRIBER_LANGUAGE = [
  CodeTableNumber.AdditionalProperty,
  CodeTableNumber.AdditionalPropertyValue,
  CodeTableNumber.AddressCountry,
  CodeTableNumber.BusinessUnitLanguageConfiguration,
  CodeTableNumber.BusinessUnitTemplate,
  CodeTableNumber.ConvergentBillerConfigurationDetail,
  CodeTableNumber.CreditCardType,
  CodeTableNumber.DefaultPasswordChallenge,
  CodeTableNumber.ExternalBillType,
  CodeTableNumber.FeatureConfiguration,
  CodeTableNumber.Language,
  CodeTableNumber.PaymentInstrumentType,
  CodeTableNumber.PersonGender,
  CodeTableNumber.PersonSuffix,
  CodeTableNumber.RegularExpression,
  CodeTableNumber.SubscriberIncomeLevelType,
  CodeTableNumber.SubscriberRequirements,
  CodeTableNumber.SubscriberType,
  CodeTableNumber.TermsAndConditionsConfiguration
];

export const CUSTOM_SECURITY_QUESTION_KEY = 'CUSTOM';

export const REGEX_CONSTANTS = {
  Date: 10000,
  Email: 2,
  Guid: 7,
  HtmlHexadecimalColor: 6,
  PasswordAlphaNumericAndSpecialChars: 16,
  PasswordContainsLowerCase: 12,
  PasswordContainsNumber: 14,
  PasswordContainsSpecialCharacter: 15,
  PasswordContainsUpperCase: 13,
  PasswordDoesNotContainSpace: 17,
  PasswordMediumLength: 10,
  PasswordStrongLength: 11,
  PasswordWeakStrength: 9,
  PostalCode: 8,
  UrlFormat: 3
};

export const FEATURE_CONFIGURATION_KEYS = {
  OFFER: 'offer',
  SUBSCRIPTION_BUNDLE: 'subscription_bundle'
};

export const INTERACTION_CATEGORY_CODES = {
  PRODUCT: '28'
};

export const MIN_INTERNAL_CODE = 10000;
export const BYTE_ID = '4';

/**
 * The default column values for code table columns in the x-CodeTableValue field.
 * Both of these correspond to the Value field in the x-CodeTableValue.
 */
export const DEFAULT_CODE_TABLE_COLUMN_VALUES: string[] = ['code', 'id'];

export const BalanceUnitCategory = {
  Data: 'Data'
};
